const EMAIL_SANDBOX_REGEX = /^\S+@\S+\.\S+#[a-z0-9_]+$/;

export default EMAIL_SANDBOX_REGEX;
